var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "chat-wrapper" } }, [
      _vm.opened
        ? _c(
            "div",
            { staticClass: "card" },
            [
              _c("chat-messages-component"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-footer" },
                [
                  _c("chat-form-component", {
                    attrs: { price: _vm.price, settext: _vm.settext }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "chat-attachment-list-right" } },
        [
          _c("h2", [_vm._v("Empfangene Dateien")]),
          _vm._v(" "),
          _c("chat-received-attachments-component", {
            attrs: { receivedattachments: _vm.receivedattachments }
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "show-all",
              attrs: { href: "/purchases/chatMedia" }
            },
            [_vm._v("Alle ansehen")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    !_vm.opened
      ? _c(
          "div",
          {
            staticClass: "chat-closed",
            on: {
              click: function($event) {
                return _vm.toggle(true)
              }
            }
          },
          [
            _vm._v("\n\t\tChat mit Leonie-Pur "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.unreadMessageCount > 0,
                    expression: "unreadMessageCount > 0"
                  }
                ],
                staticClass: "unread-messages badge badge-pill badge-info"
              },
              [_vm._v(_vm._s(_vm.unreadMessageCount))]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }